import * as types from "./dataActionTypes";
import { PATCH_CLIENT_STATUS_TYPE } from "../../components/dashboard/clients/client/clientActionTypes";

export default function enumReducer(state = {}, action) {
  switch (action.type) {
    case types.CLEAR_DATA_COUNT: {
      let newData = {};
      newData[`${action.model.name}Count`] = {};
      return { ...state, ...newData };
    }
    case types.CLEAR_DATA_LIST: {
      let newData = {};
      newData[action.model.name] = {};
      return { ...state, ...newData };
    }
    case types.CLEAR_DATA_FILE:
    case types.CLEAR_S3_DATA_FILE: {
      let newData = {};
      newData[action.model.name] = {
        ...state[action.model.name],
        shortLivedURL: null,
      };
      return { ...state, ...newData };
    }
    case types.CREATE_DATA_ITEM:
    case types.UPDATE_DATA_ITEM:
    case types.SIMPLE_POST: {
      return {
        ...state,
        submitting: true,
      };
    }
    case types.GET_DATA_FILE_FAILURE:
    case types.GET_S3_DATA_FILE_FAILURE:
    case types.POST_DATA_FILE_FAILURE:
    case types.CREATE_DATA_ITEM_FAILURE:
    case types.CREATE_DATA_ITEM_SUCCESS:
    case types.UPDATE_DATA_ITEM_FAILURE:
    case types.UPDATE_DATA_ITEM_SUCCESS:
    case types.SIMPLE_POST_FAILURE:
    case types.SIMPLE_POST_SUCCESS: {
      return {
        ...state,
        submitting: false,
      };
    }

    case types.GET_DATA_COUNT_SUCCESS: {
      let newData = {};
      newData[`${action.payload.model.name}Count`] = {
        ...state[action.payload.model.name],
        count: action.payload.data,
      };
      return { ...state, ...newData };
    }

    case types.GRAPHQL:
    case types.GET_DATA_LIST: {
      let newData = {};
      const active = action.skipClearActive && state[action.payload.model.name] ? state[action.payload.model.name].active : null;
      /**
       * If we need to  keep the active property, we can pass skipClearActive as a parameter when dispatching action.
       */
      newData[action.payload.model.name] = {
        ...state[action.payload.model.name],
        q: action.q,
        sortBy: action.sortBy,
        filters: action.filters,
        ...action.metadata,
        fetched: false,
        active: active,
        items: null,
      };
      return { ...state, ...newData };
    }
    case types.GRAPHQL_SUCCESS: {
      let newData = {};
      let dataKey = action.payload.model.key ? action.payload.model.key : action.payload.model.name;
      /** We have the option to specify a key to access response object (in request model), if key differs from model name. */
      newData[action.payload.model.name] = {
        ...state[action.payload.model.name],
        ...action.payload.data.data[dataKey],
        fetched: true,
      };
      return { ...state, ...newData };
    }
    case types.GET_DATA_LIST_SUCCESS: {
      let newData = {};
      newData[action.payload.model.name] = {
        ...state[action.payload.model.name],
        ...action.payload.data,
        fetched: true,
      };
      return { ...state, ...newData };
    }

    case types.GET_PAGELESS_DATA_LIST: {
      let newData = {};
      newData[action.payload.model.name] = {
        ...state[action.payload.model.name],
        q: action.q,
        sortBy: action.sortBy,
        filters: action.filters,
        ...action.metadata,
        active: null,
      };
      return { ...state, ...newData };
    }
    case types.GET_PAGELESS_DATA_LIST_SUCCESS: {
      let newData = {};
      newData[action.payload.model.name] = {
        ...state[action.payload.model.name],
        items: [...action.payload.data],
        fetched: true,
      };
      return { ...state, ...newData };
    }

    case types.GET_DATA_ITEM: {
      let newData = {};
      if(action.payload.model && action.payload.model.hasOwnProperty("fetching")) {
        newData[action.payload.model.name] = {
          ...state[action.payload.model.name],
          fetching: true
        };
      }
      return { ...state, ...newData };
    }
    case types.GET_DATA_ITEM_SUCCESS: {
      let newData = {};
      newData[action.payload.model.name] = {
        ...state[action.payload.model.name],
        active: action.payload.data,
        itemFetched: true,
        fetching: false
      };
      return { ...state, ...newData };
    }

    case types.GET_DATA_FILE:
    case types.GET_S3_DATA_FILE:
    case types.POST_DATA_FILE: {
      return { ...state, submitting: true };
    }
    case types.GET_DATA_FILE_SUCCESS:
    case types.GET_S3_DATA_FILE_SUCCESS:
    case types.POST_DATA_FILE_SUCCESS: {
      let newData = {};
      newData[action.payload.model.name] = {
        ...state[action.payload.model.name],
        shortLivedURL: action.payload.data,
      };
      return { ...state, ...newData, submitting: false };
    }
    case types.GET_RELATIONSHIP_ITEMS: {
      return { ...state };
    }
    case types.GET_RELATIONSHIP_ITEMS_SUCCESS: {
      const dataName = action.payload.model.name;
      const data = action.payload.data;
      return { ...state, [dataName]: data };
    }
    case types.UPDATE_LOCAL_DATA: {
      const dataName = action.model.name;
      return { ...state, [dataName]: action.values };
    }

    case PATCH_CLIENT_STATUS_TYPE: {
      /** Patches only clientStatusType on the active client without a full re-fetch. */
      const clients = state.clients || {};
      return {
        ...state,
        clients: {
          ...clients,
          active: {
            ...clients.active,
            clientStatusType: action.payload,
          },
        },
      };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/data/dataReducer.js